import Select from './select';
import Option from './option';
import './styles/index.scss';
const ExpandedSelect = Select;
ExpandedSelect.Option = Option;
export default ExpandedSelect;
